import { Box, Grid, Paper, Typography } from "@mui/material";
import { ReactNode } from "react";

interface StatCardProps {
  title: string;
  value: number | string;
  icon: ReactNode;
}

const StatCard = ({ title, value, icon }: StatCardProps) => (
  <Grid item xs={12} sm={6} md={3}>
    <Paper
      elevation={2}
      sx={{
        p: 2,
        display: "flex",
        alignItems: "center",
        borderRadius: "12px",
      }}
    >
      <Box sx={{ mr: 2, color: "primary.main" }}>{icon}</Box>
      <Box>
        <Typography color="text.secondary">{title}</Typography>
        <Typography variant="h5" fontWeight="bold">
          {value}
        </Typography>
      </Box>
    </Paper>
  </Grid>
);

export default StatCard;
